module.exports = __webpack_public_path__ + "img/goal-one-en.a5de5f5b.png";